import { useEffect } from 'react';

// SPA'da her rota için sekme başlığını ve meta açıklamayı günceller.
// Google JS'i çalıştırır; bu sayede rota başına doğru başlık/açıklama görülür.
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.head.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
}
